module.exports = __webpack_public_path__ + "img/case4.c92ab28a.jpg";